import { AlertTriangle, Receipt, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { money, dateShort, cityState } from "@/lib/format";
import { DriverSelect } from "./DriverSelect";
import { StatusSelect } from "./StatusSelect";
import { Checkbox } from "@/components/ui/checkbox";

export const isBillable = (l) => l.status === "Delivered" && !l.invoice_id;

const stop = (e) => e.stopPropagation();

export const LoadRow = ({ load: l, drivers, onOpen, onDriverChange, onStatusChange, onDriverMenu, onDelete, selected, onSelect }) => (
  <tr
    role="link"
    tabIndex={0}
    onClick={() => onOpen(l)}
    onKeyDown={(e) => { if (e.key === "Enter") onOpen(l); }}
    className={`border-t border-slate-100 cursor-pointer transition-colors hover:bg-blue-50/60 focus:outline-none focus-visible:bg-blue-50 ${selected ? "bg-blue-50/50" : ""}`}
    data-testid={`load-row-${l.load_number}`}
  >
    <td className="pl-4 pr-1 py-3 w-8" onClick={stop} onKeyDown={stop}>
      <Checkbox checked={!!selected} onCheckedChange={(v) => onSelect(l, !!v)} aria-label={`Select load ${l.load_number}`} data-testid={`row-select-${l.load_number}`} />
    </td>
    <td className="px-4 py-3">
      <div className="font-semibold text-[#002FA7]" data-testid={`row-carrier-number-${l.load_number}`}>{l.carrier_number || "—"}</div>
      <div className="text-[11px] text-slate-500 whitespace-nowrap" data-testid={`row-broker-ref-${l.load_number}`}>Ref #{l.load_number}</div>
    </td>
    <td className="px-4 py-3">{l.broker_name}</td>
    <td className="px-4 py-3 text-slate-600 whitespace-nowrap" title={`${l.pickup_location} → ${l.delivery_location}`} data-testid={`row-route-${l.load_number}`}>
      {cityState(l.pickup_location)} → {cityState(l.delivery_location)}
    </td>
    <td className="px-4 py-2 min-w-[170px]">
      <div onClick={stop} onKeyDown={stop}>
        <DriverSelect
          load={l}
          drivers={drivers}
          onChange={(id) => onDriverChange(l, id)}
          onOpenChange={onDriverMenu}
          className="h-9 bg-white"
          testId={`row-driver-select-${l.load_number}`}
        />
      </div>
    </td>
    <td className="px-4 py-3 font-medium whitespace-nowrap" data-testid={`row-rate-${l.load_number}`}>
      {money(l.rate)}
      {l.accessorials_total > 0 && <div className="text-[11px] font-normal text-slate-500" data-testid={`row-acc-${l.load_number}`}>+{money(l.accessorials_total)} acc. = {money(l.billable_total)}</div>}
    </td>
    <td className="px-4 py-2">
      <div onClick={stop} onKeyDown={stop} className="inline-block">
        <StatusSelect value={l.status} onChange={(s) => onStatusChange(l, s)} onOpenChange={onDriverMenu} testId={`row-status-select-${l.load_number}`} />
      </div>
    </td>
    <td className="px-4 py-3">
      <div className="flex gap-1.5 flex-wrap">
        {l.status === "Delivered" && !l.has_pod && (
          <span className="pill bg-amber-50 text-amber-800 border border-amber-200" data-testid="flag-missing-pod">
            <AlertTriangle className="w-3 h-3" /> Missing POD
          </span>
        )}
        {l.status === "Delivered" && !l.invoice_id && (
          <span className="pill bg-rose-50 text-rose-800 border border-rose-200" data-testid="flag-unbilled">
            <Receipt className="w-3 h-3" /> Unbilled
          </span>
        )}
      </div>
    </td>
    <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{dateShort(l.created_at)}</td>
    <td className="px-2 py-2 text-right">
      <Button
        variant="ghost"
        size="icon"
        onClick={(e) => { stop(e); onDelete(l); }}
        onKeyDown={stop}
        className="text-slate-400 hover:text-rose-600 hover:bg-rose-50"
        aria-label={`Delete load ${l.load_number}`}
        data-testid={`row-delete-${l.load_number}`}
      >
        <Trash2 className="w-4 h-4" />
      </Button>
    </td>
  </tr>
);
